import React, { useState, useEffect, useRef } from "react";
import SimpleBar from "simplebar-react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import $ from "jquery";
import ReactLoading from "react-loading";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import ParkhauspreiseEdit from "./Parkhauspreise_edit.js";

const Parkhauspreise = (props) => {
  const { t } = useTranslation();
  let [preise, setPreise] = useState([]);
  let [loaderShow, setLoaderShow] = useState(false);

  const activeRights = JSON.parse(localStorage.getItem("rights"));
  const link = "/api/CustomLogic";

  const [popUpShow, setPopUpShow] = useState(false);
  const [currentEditData, setCurrentEditData] = useState();
  const popUpContainer = useRef(null);
  const euroNumberFormat = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  });

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
    loadData();
  }, [localStorage.getItem("JWT")]);

  $(document).on("click", function (e) {
    if (
      popUpContainer.current &&
      !popUpContainer.current.contains(e.target) &&
      e.target.id != "settings-icon" &&
      !$(e.target).is(".settings-item") &&
      !$(e.target).children().hasClass("settings-item") &&
      !$(e.target).hasClass("select-icon") &&
      !$(e.target).parents(".rc-time-picker-panel").length == 1 &&
      !$(e.target).hasClass("rc-time-picker-clear") &&
      !$(e.target).hasClass("rc-time-picker-clear-icon") &&
      e.target.id != "pop-up-button"
    ) {
      setPopUpShow(false);
    }
  });

  const loadData = () => {
    if (!activeRights.includes("Parkhauspreise.Get")) {
      return;
    }
    setLoaderShow(true);

    axios
      .get(link + "/Preise/Parkhauspreis", {})
      .then((response) => {
        setPreise(response.data);
        setLoaderShow(false);
      })
      .catch((error) => {
        console.error("Error while loading Data", error);
        setLoaderShow(false);
      });
  };

  const editCreateEntry = (entry) => {
    setCurrentEditData(entry);
    setPopUpShow(true);
    // TODO: Es gefällt mir nicht, hier erst setCurrentDings aufzurufen. Kann man setPopUpShow(true, entry) machen?
  };

  const deleteEntry = (entry) => {
    if (!activeRights.includes("Parkhauspreise.Delete")) {
      return;
    }
    console.debug("Entry %o want to be deleted", entry);

    confirmAlert({
      message: "Der Eintrag '" + entry.parkhausname + "' wird gelöscht.",
      buttons: [
        {
          label: t("allgemein.ja"),
          onClick: () =>
            axios
              .delete(link + "/Preise/Parkhauspreis", {
                data: entry.id,
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                loadData();
              })
              .catch((error) => {
                console.error("Error while deleting Entry", error);
              }),
        },
        {
          label: t("allgemein.nein"),
        },
      ],
    });
  };

  function getHtmlList() {
    let htmlList = [];

    for (let i = 0; i < preise.length; i++) {
      let preis = preise[i];

      htmlList.push(
        <tr>
          <td>{preis.parkhausname}</td>
          <td>{euroNumberFormat.format(preis.preisProTag)}</td>
          <td>
            {activeRights.includes("Parkhauspreise.Update") && (
              <button
                className="button"
                id="pop-up-button"
                style={{ width: "80px" }}
                onClick={() => editCreateEntry(preis)}
              >
                {t("allgemein.Bearbeiten")}
              </button>
            )}

            {activeRights.includes("Parkhauspreise.Delete") && (
              <button
                className="button"
                id="pop-up-button"
                style={{ width: "80px", marginLeft: "10px" }}
                onClick={() => deleteEntry(preis)}
              >
                {t("allgemein.Loeschen")}
              </button>
            )}
          </td>
        </tr>
      );
    }

    return <tbody>{htmlList}</tbody>;
  }

  return (
    <div>
      {popUpShow == true && (
        <div ref={popUpContainer}>
          {
            <ParkhauspreiseEdit
              data={currentEditData}
              onChange={() => {
                setPopUpShow(false);
                loadData();
              }}
            >
              {" "}
            </ParkhauspreiseEdit>
          }
        </div>
      )}

      <div className="einstellungen-box">
        <div className="box-name">Parkhauspreise</div>
        <div style={{ overflow: "auto" }}>
          {loaderShow == true && (
            <div style={{ position: "absolute" }}>
              <ReactLoading
                type={"bars"}
                color={"#2a3042"}
                height={80}
                width={80}
                name={"Loading"}
              />
            </div>
          )}

          <table id="dataTable">
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>Parkhausname</th>
                <th style={{ textAlign: "center" }}>Preis pro Tag</th>
                <th style={{ textAlign: "right" }}>
                  {activeRights.includes("Parkhauspreise.Create") && (
                    <button
                      className="button"
                      id="pop-up-button"
                      style={{ width: "50px" }}
                      onClick={() => editCreateEntry()}
                    >
                      {t("allgemein.neu")}
                    </button>
                  )}
                </th>
              </tr>
            </thead>
            {getHtmlList()}
          </table>
        </div>
      </div>
    </div>
  );
};

export default Parkhauspreise;
